import { render, staticRenderFns } from "./priceChange.vue?vue&type=template&id=b22b9410&scoped=true"
import script from "./priceChange.vue?vue&type=script&lang=js"
export * from "./priceChange.vue?vue&type=script&lang=js"
import style0 from "./priceChange.vue?vue&type=style&index=0&id=b22b9410&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22b9410",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b22b9410')) {
      api.createRecord('b22b9410', component.options)
    } else {
      api.reload('b22b9410', component.options)
    }
    module.hot.accept("./priceChange.vue?vue&type=template&id=b22b9410&scoped=true", function () {
      api.rerender('b22b9410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/quote-by-product/productQuotationApplication/priceChange.vue"
export default component.exports